import axiosInstance from "../../../Utils/axiosInstance";

export const fetchDataForDisplayDataInDropDownApi = async () => {
    try {
        const response = await axiosInstance.get(
            "api/sourcing_management/getFilterMetaFields"
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};

interface Payload {
    Partner_ID: string;
}
export const applyFilterDataApi = async (payload: Payload) => {
    try {
        const response = await axiosInstance.post(
            "api/sourcing_management/sourcingNotificationOnclick",
            payload
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};
